import { type App, type Plugin } from 'vue'
import { ApiTrackingDriver } from '@/tracking/drivers/ApiTrackingDriver'
import type { AxiosInstance } from 'axios'
import { MockTrackingDriver } from '@/tracking/drivers/MockTrackingDriver'

export const TRACKING_PLUGIN_INJECT_KEY = Symbol('tracking')

export const TrackingPlugin: Plugin<{ http: AxiosInstance }> = {
  install(app: App, { http }) {
    if (typeof window === 'undefined') { // IS SSR
      const driver = new MockTrackingDriver()
      app.provide(TRACKING_PLUGIN_INJECT_KEY, driver)

      return
    }

    if (typeof window !== 'undefined') {// IS CSR
      const driver = new ApiTrackingDriver(http)
      app.provide(TRACKING_PLUGIN_INJECT_KEY, driver)

      return
    }

  },
}
